import React from 'react';
export function FinalCTA() {
  return <section id="cta-final" className="relative w-full py-28 px-4 sm:px-6 lg:px-8 overflow-hidden" data-id="element-71">
      {/* Background */}
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: `url('https://cdn.magicpatterns.com/uploads/rTBU1M16EuiVcoKrrSFt1A/heylloyd-image-1772459194281.png')`
    }} data-id="element-72" />
      {/* Heavy dark overlay */}
      <div className="absolute inset-0 bg-black/85" data-id="element-73" />
      {/* Gold gradient accent */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#C9A84C]/5 via-transparent to-[#C9A84C]/5" data-id="element-74" />

      {/* Content */}
      <div className="relative z-10 max-w-3xl mx-auto text-center" data-id="element-75">
        {/* Logo */}
        <img src="https://cdn.magicpatterns.com/uploads/7KGG45Zf29JRX1VVso6grv/karchek.jpg" alt="Kerchak Fighters Team" className="w-16 h-16 rounded-full object-cover border-2 border-[#C9A84C]/60 mx-auto mb-8 shadow-lg shadow-[#C9A84C]/20" data-id="element-76" />

        {/* Title */}
        <h2 className="font-heading font-bold text-white uppercase text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-tight mb-6" data-id="element-77">
          Tu primera clase{' '}
          <span className="text-[#C9A84C]" data-id="element-78">te cambia el chip.</span>
        </h2>

        {/* Body */}
        <p className="font-body text-gray-300 text-lg sm:text-xl max-w-xl mx-auto mb-10 leading-relaxed" data-id="element-79">
          Reserva tu hueco y ven a probar. En 1 sesión vas a notar la diferencia
          entre "hacer ejercicio" y{' '}
          <strong className="text-white" data-id="element-80">entrenar de verdad</strong>.
        </p>

        {/* CTA Button */}
        <a href="#precios" className="inline-block bg-[#C9A84C] hover:bg-[#E8C97A] text-black font-heading font-bold px-12 py-5 text-xl tracking-widest uppercase transition-all duration-200 shadow-2xl shadow-[#C9A84C]/30 hover:shadow-[#C9A84C]/50 hover:scale-105 mb-4" data-id="element-81">
          Ver Precios y Horarios
        </a>

        {/* Small text */}
        <p className="font-body text-gray-500 text-sm italic" data-id="element-82">
          Plazas limitadas por aforo para poder corregir bien la técnica.
        </p>
      </div>
    </section>;
}